var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useQuery } from "react-query";
import { useAuthApiClient } from "../authApi/AuthApiClientContext";
import { useLegoland } from "../LegolandContext";
import { productsFallback, validateProductsFallback } from "./fallbackData";
import { useLegolandApiClient } from "./LegolandApiClientContext";
export function getQueryResult(response, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.parseJson, parseJson = _c === void 0 ? true : _c;
    return __awaiter(this, void 0, void 0, function () {
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!response.ok) return [3 /*break*/, 4];
                    if (!parseJson) return [3 /*break*/, 2];
                    return [4 /*yield*/, response.json()];
                case 1:
                    _d = _e.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _d = response.text();
                    _e.label = 3;
                case 3: return [2 /*return*/, (_d)];
                case 4:
                    if (response.status === 401 || response.status === 404) {
                        return [2 /*return*/, null];
                    }
                    _e.label = 5;
                case 5: throw response;
            }
        });
    });
}
export function useLimitSchemasQuery(_a, queryOptions) {
    var _this = this;
    var _b = _a === void 0 ? {} : _a, productId = _b.productId;
    var apiClient = useLegolandApiClient();
    return useQuery(["legoland", "limits", "schema", productId], function () { return __awaiter(_this, void 0, void 0, function () {
        var response, schemas;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiClient.getLimitSchemas({
                        productId: productId,
                    })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, getQueryResult(response)];
                case 2:
                    schemas = _a.sent();
                    return [2 /*return*/, { schemas: schemas, response: response }];
            }
        });
    }); }, queryOptions);
}
export function useMeDetailsQuery() {
    var _this = this;
    var legolandApiClient = useLegolandApiClient();
    var authApiClient = useAuthApiClient();
    return useQuery(["legoland", "users", "me", "details"], function () { return __awaiter(_this, void 0, void 0, function () {
        var response, error_1, response, me;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 6]);
                    return [4 /*yield*/, legolandApiClient.getMeDetails()];
                case 1:
                    response = _b.sent();
                    _a = {};
                    return [4 /*yield*/, getQueryResult(response)];
                case 2: return [2 /*return*/, (_a.meDetails = _b.sent(),
                        _a.response = response,
                        _a)];
                case 3:
                    error_1 = _b.sent();
                    return [4 /*yield*/, authApiClient.getMe()];
                case 4:
                    response = _b.sent();
                    return [4 /*yield*/, getQueryResult(response)];
                case 5:
                    me = _b.sent();
                    return [2 /*return*/, {
                            meDetails: me
                                ? meToMeFallback(legolandApiClient.baseUrl, me)
                                : null,
                            response: response,
                        }];
                case 6: return [2 /*return*/];
            }
        });
    }); });
}
export function useMeProductAccessQuery(_a, queryOptions) {
    var _this = this;
    var _b = _a === void 0 ? {} : _a, productId = _b.productId;
    var currentProductId = useLegoland().productId;
    var apiClient = useLegolandApiClient();
    productId = productId !== null && productId !== void 0 ? productId : currentProductId;
    return useQuery(["legoland", "users", "me", "products", productId, "access"], function () { return __awaiter(_this, void 0, void 0, function () {
        var response, access;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiClient.getMeProductAccess({
                        productId: productId,
                    })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, getQueryResult(response)];
                case 2:
                    access = _a.sent();
                    return [2 /*return*/, { access: access, response: response }];
            }
        });
    }); }, __assign({ enabled: Boolean(productId) }, queryOptions));
}
export function useProductsQuery() {
    var _this = this;
    var apiClient = useLegolandApiClient();
    return useQuery(["legoland", "products"], function () { return __awaiter(_this, void 0, void 0, function () {
        var response, products;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiClient.getProducts()];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, getQueryResult(response)];
                case 2:
                    products = _a.sent();
                    if (products) {
                        validateProductsFallback(apiClient.baseUrl, products);
                    }
                    return [2 /*return*/, { products: products, response: response }];
            }
        });
    }); });
}
function meToMeFallback(apiUrl, _a) {
    var access = _a.access, email = _a.email, role = _a.role;
    var products = productsFallback[apiUrl];
    return {
        email: email,
        isFallback: true,
        products: access.map(function (_a) {
            var _b, _c;
            var apiKey = _a.apiKey, expiryDate = _a.expiryDate, productId = _a.productId;
            var product = products === null || products === void 0 ? void 0 : products.find(function (p) { return p.id === productId; });
            if (!product) {
                console.error("Fallback data for product with id \"".concat(productId, "\" could not be found."));
            }
            return {
                access: {
                    apiKey: apiKey,
                    expiryDate: expiryDate,
                    status: new Date().setHours(0, 0, 0, 0) > Date.parse(expiryDate)
                        ? "EXPIRED"
                        : "GRANTED",
                },
                displayName: (_b = product === null || product === void 0 ? void 0 : product.displayName) !== null && _b !== void 0 ? _b : productId.toUpperCase(),
                id: productId,
                isFallback: true,
                url: (_c = product === null || product === void 0 ? void 0 : product.redirectLink) !== null && _c !== void 0 ? _c : "#",
            };
        }),
        role: role,
        settings: {
            clockFormat: "24",
            dateFormat: "DDMMYYYY",
            units: "KM",
            weekStart: "MONDAY",
        },
    };
}
export function useReleaseNotesProductId(productId) {
    var _a;
    var _b = useLegoland(), currentProductId = _b.productId, releaseNotesUrl = _b.releaseNotesUrl;
    return (_a = productId !== null && productId !== void 0 ? productId : currentProductId) !== null && _a !== void 0 ? _a : (releaseNotesUrl ? "ll" : undefined);
}
export function useReleaseNotesQuery(_a, options) {
    var _this = this;
    var _b = _a === void 0 ? {} : _a, productId = _b.productId;
    var apiClient = useLegolandApiClient();
    productId = useReleaseNotesProductId(productId);
    return useQuery(["legoland", "release-notes", productId], function () { return __awaiter(_this, void 0, void 0, function () {
        var response, releaseNotes;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, apiClient.getReleaseNotes({
                        productId: productId,
                    })];
                case 1:
                    response = _c.sent();
                    return [4 /*yield*/, getQueryResult(response)];
                case 2:
                    releaseNotes = (_b = (_a = (_c.sent())) === null || _a === void 0 ? void 0 : _a.content) !== null && _b !== void 0 ? _b : null;
                    return [2 /*return*/, releaseNotes];
            }
        });
    }); }, __assign({ enabled: Boolean(productId) }, options));
}
export function useUserProduct(_a) {
    var _b, _c;
    var _d = _a === void 0 ? {} : _a, productId = _d.productId;
    var currentProductId = useLegoland().productId;
    var meDetailsQuery = useMeDetailsQuery();
    return (_c = (_b = meDetailsQuery.data) === null || _b === void 0 ? void 0 : _b.meDetails) === null || _c === void 0 ? void 0 : _c.products.find(function (p) { return p.id === (productId !== null && productId !== void 0 ? productId : currentProductId); });
}
//# sourceMappingURL=legolandApiHooks.js.map